/* eslint-disable @typescript-eslint/no-explicit-any */
import request from "@/request/index";

/************************* 达人库 **********************/

/**
 * @function 上传文件
 * @param param 
 * @returns 
 */
export const postOssUploadFile = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/oss/upload-file',
            method: 'post',
            data: param,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 钉钉上传文件
 * @param param 
 * @returns 
 */
export const postDingtalkUploadFile = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/dingtalk-oa/upload-file',
            method: 'post',
            data: param,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取地区
 * @param param 
 * @returns 
 */
export const getAreaAll = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/area/all',
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取行业列表
 * @param param 
 * @returns 
 */
export const getTradeList = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/trade/list',
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取枚举信息
 * @param param 
 * @returns 
 */
export const getCommonEnums = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/common/enums',
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 用户列表
 * @param param 
 * @returns 
 */
export const postUserList = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/user/list',
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 导出的字段
 * @param param 
 * @returns 
 */
export const getExportField = (param: any, type: any) => {
    const templateUrl: any = {
        'project': '/api/project/export-field',
        'po_order': '/api/purchase-order/export-field',
        'father_order': '/api/pre-author-purchase/export-field',
        'child_order': '/api/author-purchase/export-field',
        'offline_order': '/api/pay-offline-purchase/export-field',
        'ad_feed': '/api/put-flow/export-field',
        'ad_feed_consume': '/api/put-flow-consume/export-field',
        'ad_feed_bill': '/api/put-flow-bill/export-field',
        'project_service_charge': '/api/project-serve/export-field',
        'offline_ad_feed': '/api/pay-offline-flow/export-field',
        'offline_other': '/api/pay-offline-other/export-field',
        'hard_hiro': '/api/hard-ad/export-field',
        'settlement': '/api/settlement/export-field',
        'blue_invoice': '/api/invoice-blue/export-field',
        'platform_blue_invoice': '/api/invoice-blue/export-field',
        'red_invoice': '/api/invoice-red/export-field',
        'refund_order': '/api/refund-order/export-field',
        'return_order': '/api/return-order/export-field',
        // 'platform-rebate-export': '/api/return-order/platform-rebate-export/export-field',
        'outer_author_purchase': '/api/author-purchase-outside/export-field',
        'outer_ad_feed': '/api/put-flow-outside-recharge/export-field',
        'ad_outside': '/api/ad-outside/export-field',
        'outer_ad_feed_consume': '/api/put-flow-outside-consume/export-field',
        'outer_hard_hiro': '/api/hard-ad-outside/export-field',
        'purse_platform_wallet': '/api/wallet/platform-wallet-bill/export-field',
        'purse_account_wallet': '/api/wallet/account-wallet-bill/export-field',
        'purse_credit': '/api/wallet/credit-bill/export-field',
        'ad_creativity': '/api/jg-creativity/export-field',
        'inner_author': '/api/inside-author/export-field',
        'red_order_manage': '/api/author-order/export-field',
        'red_rebate_contract': '/api/author-rebate-contract/export-field',
        'red_rebate_pay': '/api/author-rebate-pay/export-field',
        'red_author_remuneration': '/api/author-work-fee-pay/export-field',
        'transfer_order': '/api/return-transfer-order/export-field',
        'rouwen_project': '/api/rouwen-project/export-field',
        'rouwen_author_note': '/api/rouwen-note/export-field',
        'rouwen_live_pay': '/api/rouwen-live-pay/export-field',
        'rouwen_jg_put_flow': '/api/rouwen-flow/export-field',
        'rouwen_sale_rebate': '/api/rouwen-rebate-pay/export-field',
        'live_stream_plan': '/api/rouwen-live-plan/export-field',
        'live_stream_expenditure': '/api/rouwen-live-pay/export-field',
        'live_stream_commission': '/api/rouwen-bill/export-field',
        'po_rebate_pay': '/api/po-rebate-pay/export-field',
        'outside_rebate_pay': '/api/outside-rebate-pay/export-field',
        'rebate_return_bad': '/api/rebate-return-bad/export-field',
        'koc_work_fee': '/api/koc-work-fee/export-field'
    };
    const url = templateUrl[type];
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 项目导出模板
 * @param param 
 * @returns 
 */
export const getExportTemplate = (param: any, type: any) => {
    const templateUrl: any = {
        'project': '/api/project/export-template',
        'po_order': '/api/purchase-order/export-template',
        'father_order': '/api/pre-author-purchase/export-template',
        'child_order': '/api/author-purchase/export-template',
        'offline_order': '/api/pay-offline-purchase/export-template',
        'ad_feed': '/api/put-flow/export-template',
        'ad_feed_consume': '/api/put-flow-consume/export-template',
        'ad_feed_bill': '/api/put-flow-bill/export-template',
        'project_service_charge': '/api/project-serve/export-template',
        'offline_ad_feed': '/api/pay-offline-flow/export-template',
        'offline_other': '/api/pay-offline-other/export-template',
        'hard_hiro': '/api/hard-ad/export-template',
        'settlement': '/api/settlement/export-template',
        'blue_invoice': '/api/invoice-blue/export-template',
        'platform_blue_invoice': '/api/invoice-blue/export-template',
        'red_invoice': '/api/invoice-red/export-template',
        'refund_order': '/api/refund-order/export-template',
        'return_order': '/api/return-order/export-template',
        // 'platform-rebate-export': '/api/platform-rebate-export/export-template',
        'outer_author_purchase': '/api/author-purchase-outside/export-template',
        'outer_ad_feed': '/api/put-flow-outside-recharge/export-template',
        'ad_outside': '/api/ad-outside/export-template',
        'outer_ad_feed_consume': '/api/put-flow-outside-consume/export-template',
        'outer_hard_hiro': '/api/hard-ad-outside/export-template',
        'purse_platform_wallet': '/api/wallet/platform-wallet-bill/export-template',
        'purse_account_wallet': '/api/wallet/account-wallet-bill/export-template',
        'purse_credit': '/api/wallet/credit-bill/export-template',
        'ad_creativity': '/api/jg-creativity/export-template',
        'inner_author': '/api/inside-author/export-template',
        'red_order_manage': '/api/author-order/export-template',
        'red_bill_manage': '/api/author-bill/export-template',
        'red_rebate_contract': '/api/author-rebate-contract/export-template',
        'red_rebate_pay': '/api/author-rebate-pay/export-template',
        'red_author_remuneration': '/api/author-work-fee-pay/export-template',
        'transfer_order': '/api/return-transfer-order/export-template',
        'rouwen_project': '/api/rouwen-project/export-template',
        'rouwen_author_note': '/api/rouwen-note/export-template',
        'rouwen_live_pay': '/api/rouwen-live-pay/export-template',
        'rouwen_jg_put_flow': '/api/rouwen-flow/export-template',
        'rouwen_sale_rebate': '/api/rouwen-rebate-pay/export-template',
        'live_stream_plan': '/api/rouwen-live-plan/export-template',
        'live_stream_expenditure': '/api/rouwen-live-pay/export-template',
        'live_stream_commission': '/api/rouwen-bill/export-template',
        'po_rebate_pay': '/api/po-rebate-pay/export-template',
        'outside_rebate_pay': '/api/outside-rebate-pay/export-template',
        'rebate_return_bad': '/api/rebate-return-bad/export-template',
        'koc_work_fee': '/api/koc-work-fee/export-template'
    };
    const url = templateUrl[type];
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 项目导出
 * @param param 
 * @returns 
 */
export const postExport = (param: any, type: any) => {
    const exportUrl: any = {
        'project': '/api/project/export',
        'po_order': '/api/purchase-order/export',
        'father_order': '/api/pre-author-purchase/export',
        'child_order': '/api/author-purchase/export',
        'offline_order': '/api/pay-offline-purchase/export',
        'ad_feed': '/api/put-flow/export',
        'ad_feed_consume': '/api/put-flow-consume/export',
        'ad_feed_bill': '/api/put-flow-bill/export',
        'project_service_charge': '/api/project-serve/export',
        'offline_ad_feed': '/api/pay-offline-flow/export',
        'offline_other': '/api/pay-offline-other/export',
        'hard_hiro': '/api/hard-ad/export',
        'settlement': '/api/settlement/export',
        'blue_invoice': '/api/invoice-blue/export',
        'platform_blue_invoice': '/api/invoice-blue/export',
        'red_invoice': '/api/invoice-red/export',
        'refund_order': '/api/refund-order/export',
        'return_order': '/api/return-order/export',
        'return_transfer_order': '/api/return-transfer-order/export',
        'platform-rebate-export': '/api/return-order/platform-rebate-export',
        'outer_author_purchase': '/api/author-purchase-outside/export',
        'outer_ad_feed': '/api/put-flow-outside-recharge/export',
        'ad_outside': '/api/ad-outside/export',
        'outer_ad_feed_consume': '/api/put-flow-outside-consume/export',
        'outer_hard_hiro': '/api/hard-ad-outside/export',
        'purse_platform_wallet': '/api/wallet/platform-wallet-bill/export',
        'purse_account_wallet': '/api/wallet/account-wallet-bill/export',
        'purse_credit': '/api/wallet/credit-bill/export',
        'ad_creativity': '/api/jg-creativity/export',
        'inner_author': '/api/inside-author/export',
        'outside_author': '/api/archives-author/export',
        'red_order_manage': '/api/author-order/export',
        'red_bill_manage': '/api/author-bill/export',
        'red_rebate_contract': '/api/author-rebate-contract/export',
        'red_rebate_pay': '/api/author-rebate-pay/export',
        'red_author_remuneration': '/api/author-work-fee-pay/export',
        'transfer_order': '/api/return-transfer-order/export',
        'rouwen_project': '/api/rouwen-project/export',
        'rouwen_author_note': '/api/rouwen-note/export',
        'rouwen_live_pay': '/api/rouwen-live-pay/export',
        'rouwen_jg_put_flow': '/api/rouwen-flow/export',
        'rouwen_sale_rebate': '/api/rouwen-rebate-pay/export',
        'live_stream_plan': '/api/rouwen-live-plan/export',
        'live_stream_expenditure': '/api/rouwen-live-pay/export',
        'live_stream_commission': '/api/rouwen-bill/export',
        'po_rebate_pay': '/api/po-rebate-pay/export',
        'outside_rebate_pay': '/api/outside-rebate-pay/export',
        'rebate_return_bad': '/api/rebate-return-bad/export',
        'koc_work_fee': '/api/koc-work-fee/export'
    };
    const url = exportUrl[type];
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'post',
            data: param,
            responseType: 'blob',
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 保存导出字段
 * @param param 
 * @returns 
 */
export const postExportFieldSave = (param: any, type: any) => {
    const fieldSaveUrl: any = {
        'project': '/api/project/export-field-save',
        'po_order': '/api/purchase-order/export-field-save',
        'father_order': '/api/pre-author-purchase/export-field-save',
        'child_order': '/api/author-purchase/export-field-save',
        'offline_order': '/api/pay-offline-purchase/export-field-save',
        'ad_feed': '/api/put-flow/export-field-save',
        'ad_feed_consume': '/api/put-flow-consume/export-field-save',
        'ad_feed_bill': '/api/put-flow-bill/export-field-save',
        'project_service_charge': '/api/project-serve/export-field-save',
        'offline_ad_feed': '/api/pay-offline-flow/export-field-save',
        'offline_other': '/api/pay-offline-other/export-field-save',
        'hard_hiro': '/api/hard-ad/export-field-save',
        'settlement': '/api/settlement/export-field-save',
        'blue_invoice': '/api/invoice-blue/export-field-save',
        'platform_blue_invoice': '/api/invoice-blue/export-field-save',
        'red_invoice': '/api/invoice-red/export-field-save',
        'refund_order': '/api/refund-order/export-field-save',
        'return_order': '/api/return-order/export-field-save',
        // 'platform-rebate-export': '/api/platform-rebate-export/export-field-save',
        'outer_author_purchase': '/api/author-purchase-outside/export-field-save',
        'outer_ad_feed': '/api/put-flow-outside-recharge/export-field-save',
        'ad_outside': '/api/ad-outside/export-field-save',
        'outer_ad_feed_consume': '/api/put-flow-outside-consume/export-field-save',
        'outer_hard_hiro': '/api/hard-ad-outside/export-field-save',
        'purse_platform_wallet': '/api/wallet/platform-wallet-bill/export-field-save',
        'purse_account_wallet': '/api/wallet/account-wallet-bill/export-field-save',
        'purse_credit': '/api/wallet/credit-bill/export-field-save',
        'ad_creativity': '/api/jg-creativity/export-field-save',
        'inner_author': '/api/inside-author/export-field-save',
        'red_order_manage': '/api/author-order/export-field-save',
        'red_bill_manage': '/api/author-bill/export-field-save',
        'red_rebate_contract': '/api/author-rebate-contract/export-field-save',
        'red_rebate_pay': '/api/author-rebate-pay/export-field-save',
        'red_author_remuneration': '/api/author-work-fee-pay/export-field-save',
        'transfer_order': '/api/return-transfer-order/export-field-save',
        'rouwen_project': '/api/rouwen-project/export-field-save',
        'rouwen_author_note': '/api/rouwen-note/export-field-save',
        'rouwen_live_pay': '/api/rouwen-live-pay/export-field-save',
        'rouwen_jg_put_flow': '/api/rouwen-flow/export-field-save',
        'rouwen_sale_rebate': '/api/rouwen-rebate-pay/export-field-save',
        'live_stream_plan': '/api/rouwen-live-plan/export-field-save',
        'live_stream_expenditure': '/api/rouwen-live-pay/export-field-save',
        'live_stream_commission': '/api/rouwen-bill/export-field-save',
        'po_rebate_pay': '/api/po-rebate-pay/export-field-save',
        'outside_rebate_pay': '/api/outside-rebate-pay/export-field-save',
        'rebate_return_bad': '/api/rebate-return-bad/export-field-save',
        'koc_work_fee': '/api/koc-work-fee/export-field-save'
    };
    const url = fieldSaveUrl[type];
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'post',
            data: param,
            responseType: 'blob',
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 回调-审批流程
 * @param param 
 * @returns 
 */
export const posApprovalCallback = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/dingtalk-oa/approval-callback',
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 转交
 * @param param 
 * @returns 
 */
export const posRedirectAddNode = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/approval/redirect-add-node',
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 刷新审批流程
 * @param param 
 * @returns 
 */
export const getRefreshApprovalHistory = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/dingtalk-oa/refresh-approval-history',
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 列表数据查询-广告投流
 * @param param 
 * @returns 
 */
export const postListPutFlow = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/project/list-put-flow',
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 投流消耗单-查询列表
 * @param param 
 * @returns 
 */
export const postPutFlowConsumeList = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/put-flow-consume/list',
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取待审批数量
 * @param param 
 * @returns 
 */
export const getWaitApprovalCount = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/common/wait-approval-count',
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取下一个待审批
 * @param param 
 * @returns 
 */
export const getNextApproval = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/common/next-approval',
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 品牌查询
 * @param param 
 * @returns 
 */
export const postSearchBrand = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/pgy/search-brand',
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 详情
 * @param param 
 * @returns 
 */
export const getDetail = (param: any, type: any) => {
    const urlObj: any = {
        'blue_invoice': '/api/invoice-blue/detail',
        'red_invoice': '/api/invoice-red/detail',
        'platform_blue_invoice': '/api/invoice-blue/detail'
    };
    const url = urlObj[type];
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'get',
            params: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 详情
 * @param param 
 * @returns 
 */
export const postRefreshData = (param: any, type: any) => {
    const urlObj: any = {
        'project': '/api/project/refresh-data',
        'purchase_order': '/api/purchase-order/refresh-data',
        'red_man_order': '/api/author-order/refresh-data',
        'rouwen_project_manage': '/api/rouwen-project/refresh-data',
        'inner_order_ad_feed': '/api/put-flow/refresh-data',
        'rouwen_live_plan': '/api/rouwen-live-plan/refresh-data'
    };
    const url = urlObj[type];
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 更新信息
 * @param param 
 * @returns 
 */
export const postUpdateInfo = (param: any, key: any) => {
    const api: any = {
        'red_author_remuneration': '/api/author-work-fee-pay/update-info',
        'offline_author_purchase': '/api/pay-offline-purchase/update-info',
        'offline_payment_order': '/api/pay-offline-flow/update-info',
        'red_sale_rebate': '/api/author-rebate-pay/update-info',
        'rou_sale_rebate': '/api/rouwen-rebate-pay/update-info',
        'red_live_stream_expenditure': '/api/rouwen-live-pay/update-info',
        'gg_inner_po_order': '/api/purchase-order/update-info',
        'po_rebate_pay': '/api/po-rebate-pay/update-info',
        'outside_rebate_pay': '/api/outside-rebate-pay/update-info',
        'author_purchase': '/api/author-purchase/update-info',
        'put_flow_bill': '/api/put-flow-bill/update-info',
        'inner_order_hard_ad': '/api/hard-ad/update-info',
        'project_service_charge': '/api/project-serve/update-info',
        'inner_order_other': '/api/pay-offline-other/update-info'
    };
    return new Promise((resolve, reject) => {
        request({
            url: api[key],
            method: 'post',
            data: param,
            headers: {
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};